var map = {
	"./BCH.svg": 868,
	"./BTC.svg": 869,
	"./DASH.svg": 870,
	"./ETC.svg": 871,
	"./ETH.svg": 872,
	"./LTC.svg": 873,
	"./XMR.svg": 874,
	"./XRP.svg": 875,
	"./ZEC.svg": 876
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 867;


//////////////////
// WEBPACK FOOTER
// ./src/images/crypto-icons ^\.\/.*\.svg$
// module id = 867
// module chunks = 0